import Box from "@mui/material/Box";

import { SizingTypeValue } from "../../../types/enums";
import { Roles } from "../../../utils/enums";
import TermSheetCell from "../../termSheet/TermSheetCell";

import CustomChip from "../CustomChip";

const headClass = {
  background: "#E4EAFF",
  color: "var(--New-Colors-BTN, #362866)",
  fontFamily: "Poppins",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  borderRadius: "none",
  borderRight: "1px solid #BFBFBF",
};

export const TableColumns = [
  {
    title: "Evaluation Id",
    id: "evaluationId",
    hidden: () => false,
    tbField: "evaluationId",
    renderCustom: (
      data: any,
      styles: any,
      handleDropdownSelection: any,
      onLinkClick: any,
    ) => {
      return (
        <span
          style={{
            cursor: "pointer",
          }}
        >
          <a
            href={onLinkClick(data.loanType, data.loanId, data.productType)}
            style={{
              textDecoration: "underline",
              cursor: "pointer",
              color: "var(--Primary-PrimaryMain-700, #40128B)",
              fontFamily: "Poppins",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "normal",
            }}
            className="eval-link"
          >
            {data.evaluationId}
          </a>
        </span>
      );
    },
    width: 140,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Application Name",
    id: "applicationName",
    hidden: () => false,
    tbField: "applicationName",
    width: 200,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.applicationName}
        >
          {data?.applicationName}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Sizing Type",
    id: "sizingType",
    hidden: (props: any) => !props?.merchants,
    tbField: "sizingType",
    showDropDownFilter: true,
    width: 200,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.sizingType}
        >
          {data?.sizingType}
        </div>
      );
    },
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Loan Type",
    id: "loanType",
    hidden: () => false,
    showDropDownFilter: true,
    tbField: "productType",
    width: 136,
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Loan Amount",
    id: "loanAmount",
    hidden: () => false,
    tbField: "loanAmount",
    width: 140,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Interest Rate",
    id: "interestRate",
    hidden: () => false,
    tbField: "interestRate",
    width: 140,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Created On",
    id: "createdOn",
    hidden: () => false,
    tbField: "createdOn",
    width: 120,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Created By",
    id: "createdBy",
    showDropDownFilter: true,
    hidden: (data: any) =>
      data?.sizingType === SizingTypeValue.QUICK_LOAN_SIZING ||
      data?.isLoanOfficer,
    tbField: "createdBy",
    width: 180,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.createdBy}
        >
          {data?.createdBy}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
  },
  {
    title: "Loan Status",
    id: "loanStatus",
    hidden: () => false,
    tbField: "loanStatus",
    width: 180,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Waiver Status",
    id: "waiverReviewStatus",
    hidden: () => false,
    tbField: "waiverReviewStatus",
    width: 160,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Price Exception",
    id: "waiverStatus",
    hidden: (data: any) => !data?.merchants,
    showDropDownFilter: true,
    tbField: "waiverStatus",
    width: 220,
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Rate as of",
    id: "ratesAsOf",
    hidden: () => false,
    showDateRangeFilter: true,
    tbField: "ratesAsOf",
    width: 136,
    boxProps: {
      ml: "auto",
      lineHeight: 0,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Term Sheet",
    id: "termSheet",
    hidden: (data: any) => !data.termSheet,
    tbField: "termSheet",
    width: 200,
    renderCustom: (data: any) => {
      const label = data?.termSheet;
      return (
        <div>
          {label === "Not Generated" ? (
            <div
              style={{ textOverflow: "ellipsis", overflow: "hidden" }}
              title={label}
            >
              {label}
            </div>
          ) : (
            <div>
              <TermSheetCell label={label} rowData={data} />
            </div>
          )}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Street Address",
    id: "streetAddress",
    hidden: (data: any) =>
      data?.sizingType === SizingTypeValue.QUICK_LOAN_SIZING,
    tbField: "streetAddress",
    width: 260,
    renderCustom: (data: any) => {
      return (
        <div
          style={{ textOverflow: "ellipsis", overflow: "hidden" }}
          title={data?.streetAddress}
        >
          {data?.streetAddress}
        </div>
      );
    },
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "City",
    id: "city",
    hidden: () => false,
    tbField: "city",
    width: 160,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Postal",
    id: "postal",
    hidden: () => false,
    tbField: "postal",
    width: 120,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Escalation Status",
    id: "status",
    showDropDownFilter: true,
    hidden: ({
    isUnderwriter,
    sizingType,
  }: {
    isUnderwriter: boolean;
    sizingType: string;
  }) =>
    sizingType === SizingTypeValue.QUICK_LOAN_SIZING,
    tbField: "status",
    renderCustom: (data: any) => {
      // Latest entry, not just a Pending one - once resolved (Rejected),
      // that's the status to show, not whatever the loan's escalation
      // history looked like before.
      const escalations = Array.isArray(data?.escalations)
        ? data.escalations
        : [];
      const latestEscalation = escalations[escalations.length - 1];
      let status = latestEscalation?.underwritingStatus;
      // A Pending entry created BY underwriter/credit_committee only exists
      // because they approved the previous stage and auto-escalated it on
      // to Capital Markets (see Header.tsx's resolveEscalation / the Waiver
      // flow) - from their perspective that's an approval, even though the
      // loan itself is Pending again, now with Capital Markets. A Pending
      // entry created by loan_officer, in contrast, is a fresh escalation
      // nobody has acted on yet, and stays "Pending".
      if (
        status === "Pending" &&
        (latestEscalation?.createdByRole === Roles.underwriter ||
          latestEscalation?.createdByRole === Roles.creditCommittee)
      ) {
        status = "Approved";
      }
      if (!status) return <span> - </span>;
      return (
        <CustomChip
          size="small"
          label={status}
          className={
            status === "Pending"
              ? "pending-chip"
              : status === "Approved"
                ? "approved-chip"
                : "rejected-chip"
          }
          variant="outlined"
        />
      );
    },
    width: 180,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Escalation Date",
    id: "escalationDate",
    hidden: ({
    isUnderwriter,
    sizingType,
  }: {
    isUnderwriter: boolean;
    sizingType: string;
  }) =>
    sizingType === SizingTypeValue.QUICK_LOAN_SIZING,
    tbField: "escalationDate",
    renderCustom: (
      data: any,
      styles: any,
      handleDropdownSelection: any,
      onLinkClick: any,
    ) => {
      // Latest entry, not just a Pending one - a resolved (Rejected) entry
      // carries its date on updatedOn rather than createdOn.
      const escalations = Array.isArray(data?.escalations)
        ? data.escalations
        : [];
      const latestEscalation = escalations[escalations.length - 1];
      const escalationDate =
        latestEscalation?.createdOn || latestEscalation?.updatedOn;
      return (
        <span>
          {escalationDate
            ? new Date(escalationDate).toLocaleDateString()
            : " - "}
        </span>
      );
    },
    width: 200,
    headStyle: {
      ...headClass,
    },
  },
  {
    title: "Escalation Ageing",
    id: "escalationAgeing",
    hidden: ({
    isUnderwriter,
    sizingType,
  }: {
    isUnderwriter: boolean;
    sizingType: string;
  }) =>
    sizingType === SizingTypeValue.QUICK_LOAN_SIZING,
    tbField: "escalationAgeing",
    renderCustom: (data: any) => {
      // Days between the latest escalation's date and today - same date
      // source as the Escalation Date column above, so the two always agree.
      const escalations = Array.isArray(data?.escalations)
        ? data.escalations
        : [];
      const latestEscalation = escalations[escalations.length - 1];
      const escalationDate =
        latestEscalation?.createdOn || latestEscalation?.updatedOn;
      if (!escalationDate) return <span> - </span>;
      const ageingDays = Math.max(
        0,
        Math.floor(
          (Date.now() - new Date(escalationDate).getTime()) /
            (1000 * 60 * 60 * 24),
        ),
      );
      return <span>{`${ageingDays} ${ageingDays === 1 ? "day" : "days"}`}</span>;
    },
    width: 180,
    headStyle: {
      ...headClass,
    },
  },
  // {
  //   title: "Sizing Stage",
  //   id: "sizingType",
  //     hidden: (data: any)=> !data?.merchants,
  //   showDropDownFilter: true,
  //   tbField: "sizingType",
  //   width: 160,
  //   boxProps: {
  //     ml: "auto",
  //     lineHeight: 0,
  //     display: "flex",
  //     flexDirection: "row",
  //     alignItems: "center",

  //   },
  // },
];
